import { Link, useNavigate } from 'react-router-dom'
import { MapPin, Gift, MessageCircle, Settings, ChevronRight, Mail, RefreshCcw, LogOut, Phone, ChevronLeftIcon, Truck, Users } from 'lucide-react'
import { SiLine } from 'react-icons/si'
import { useSubscription } from '../context/SubscriptionContext'
import { useState, useEffect } from 'react'
import { authService } from '../services'
import ConfirmationModal from '../components/ConfirmationModal'
import toast from 'react-hot-toast'
import useBottomNavPadding from '../hooks/useBottomNavPadding'
import { useTranslation } from 'react-i18next'
import { usePageTitle, setDocumentTitle } from '../utils/translation'
import { PageHeader } from '../components/ui/PageHeader'
import { ReferralCodeCard } from '../components/ReferralCodeCard'
import { ReferralHistoryCard } from '../components/ReferralHistoryCard'
import { formatPhoneForDisplay } from '../utils/phoneUtils'

// SVG Icons
const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path>
    <circle cx="12" cy="10" r="3"></circle>
  </svg>
);

const GiftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="8" width="18" height="4" rx="1"></rect>
    <path d="M12 8v13"></path>
    <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path>
    <path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path>
  </svg>
);

const MessageCircleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
  </svg>
);

const SettingsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);

const ChevronRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="m9 18 6-6-6-6"></path>
  </svg>
);

const MailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
  </svg>
);

const RefreshCcwIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 2v6h6"></path>
    <path d="M21 12A9 9 0 0 0 6 5.3L3 8"></path>
    <path d="M21 22v-6h-6"></path>
    <path d="M3 12a9 9 0 0 0 15 6.7l3-2.7"></path>
  </svg>
);

const LogOutIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
    <polyline points="16 17 21 12 16 7"></polyline>
    <line x1="21" y1="12" x2="9" y2="12"></line>
  </svg>
);

const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
  </svg>
);

const TruckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10 17h4V5H2v12h3"></path>
    <path d="M20 17h2v-3.34a4 4 0 0 0-1.17-2.83L19 9h-5v8h1"></path>
    <circle cx="7.5" cy="17.5" r="2.5"></circle>
    <circle cx="17.5" cy="17.5" r="2.5"></circle>
  </svg>
);

// Add Users icon for referrals
const UsersIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>
);

// Add LINE icon
const LineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="18" x="3" y="3" rx="2" ry="2"></rect>
    <line x1="8" y1="12" x2="8" y2="16"></line>
    <line x1="16" y1="12" x2="16" y2="16"></line>
    <line x1="12" y1="8" x2="12" y2="16"></line>
  </svg>
);

export default function Me() {
  const navigate = useNavigate()
  const { subscription = {}, isLoading } = useSubscription()
  const [user, setUser] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [fetchingUser, setFetchingUser] = useState(false)
  const [showConfirmationLogout, setShowConfirmationLogout] = useState<boolean>(false)
  const { t } = useTranslation()
  
  // Get translated page title
  const pageTitle = usePageTitle('account.title', 'My Account')
  
  // Apply bottom padding for the navigation
  useBottomNavPadding()

  useEffect(() => {
    // Set the document title
    setDocumentTitle(pageTitle)
    
    // Check if user is authenticated before fetching data
    if (!authService.isAuthenticated()) {
      console.log('User is not authenticated, redirecting to login')
      navigate('/login')
      return
    }
    
    // Get current user data
    fetchUserData()
  }, [navigate, pageTitle])

  const fetchUserData = async () => {
    setFetchingUser(true)
    setError(null)
    
    try {
      const userData = await authService.getCurrentUser()
      setUser(userData)
    } catch (error) {
      console.error('Error fetching user data:', error)
      setError(t('account.loadError'))
    } finally {
      setFetchingUser(false)
    }
  }

  const handleSendVerificationEmail = async () => {
    if (!user?.email) return
    
    setLoading(true)
    setMessage('')
    
    try {
      await authService.sendVerificationEmail(user.email)
      setMessage(t('account.verificationSent'))
    } catch (error) {
      console.error('Error sending verification email:', error)
      setMessage(t('account.verificationFailed'))
    } finally {
      setLoading(false)
    }
  }

  const handleLogout = async () => {
    toast.loading(t('auth.loggingOut'))
    await authService.logout()
    navigate('/login')
    toast.dismiss()
    toast.success(t('auth.loggedOutSuccess'))
  }

  return (
    <main className="min-h-screen bg-white">
      {/* Header */}
      <PageHeader title={t('account.title')} />

      {/* Main Content */}
      <div className="p-4 space-y-4">
        {/* Error Message */}
        {error && (
          <div className="bg-red-50 border border-red-200 rounded-xl p-4">
            <p className="text-red-700">{error}</p>
            <button 
              onClick={fetchUserData}
              disabled={fetchingUser}
              className="mt-2 px-4 py-2 bg-red-100 hover:bg-red-200 text-red-800 rounded text-sm"
            >
              {fetchingUser ? t('common.retrying') : t('common.retry')}
            </button>
          </div>
        )}

        {/* Main Info Section */}
        <div className="space-y-3">
          {/* Account Information - Big Card (2:1 ratio) */}
          <div className="bg-white rounded-xl px-4 py-6 border border-gray-200 shadow-sm">
            <div className="flex items-center h-full">
              <div className="flex-shrink-0">
                {user?.email ? (
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                    <MailIcon />
                  </div>
                ) : user?.phone ? (
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <PhoneIcon />
                  </div>
                ) : (
                  <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center">
                    <MailIcon />
                  </div>
                )}
              </div>
              <div className="ml-4 flex-grow">
                <h2 className="font-semibold text-lg text-gray-900">
                  {user?.email || (user?.phone ? formatPhoneForDisplay(user.phone) : null) || t('account.information')}
                </h2>
                <p className="text-sm text-gray-600">
                  {user?.email ? (
                    <>
                      {t('account.email')} • {user.email_verified ? t('common.verified') : t('account.unverified')}
                    </>
                  ) : user?.phone ? (
                    t('account.phone')
                  ) : (
                    t('account.loadingInfo')
                  )}
                </p>
                {!user?.email_verified && user?.email && (
                  <button 
                    onClick={handleSendVerificationEmail}
                    disabled={loading}
                    className="text-xs text-blue-600 mt-1 hover:text-blue-800"
                  >
                    {loading ? t('common.loading') : t('account.verifyEmail')}
                  </button>
                )}
                {message && <p className="text-xs text-gray-600 mt-1">{message}</p>}
              </div>
            </div>
          </div>

          {/* Bottom Cards Grid (1:1 ratio) */}
          <div className="grid grid-cols-2 gap-3">
            {/* Delivery Activity Card */}
            <Link 
              to="/delivery-activity"
              className="bg-white rounded-xl p-4 flex flex-col justify-start items-start hover:bg-gray-50 transition-colors border border-gray-200 shadow-sm"
            >
              <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center mb-2">
                <TruckIcon />
              </div>
              <span className="text-sm font-medium text-center">{t('pages.deliveryActivity')}</span>
            </Link>
            {/* Referrals Card */}
            <Link 
              to="/referral-program"
              className="bg-white rounded-xl p-4 flex flex-col justify-start items-start hover:bg-gray-50 transition-colors border border-gray-200 shadow-sm"
            >
              <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center mb-2">
                <UsersIcon />
              </div>
              <span className="text-sm font-medium text-center">{t('account.referral.manageReferrals')}</span>
            </Link>
          </div>
        </div>

        {/* Connect with LINE - Small Card */}
        {!user?.identities?.find((item: any) => item.type === 'line' && !item.revoked_at) && (
          <Link 
            to="/connect-line"
            className="bg-white rounded-xl p-4 flex items-center justify-between hover:bg-gray-50 transition-colors border border-gray-200 shadow-sm"
          >
            <div className="flex items-center">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                <SiLine size={16} color="white" />
              </div>
              <span className="ml-3 text-sm font-medium">Connect with LINE</span>
            </div>
            <ChevronRightIcon />
          </Link>
        )}

        {/* LINE Connected Status */}
        {user?.identities?.find((item: any) => item.type === 'line' && !item.revoked_at) && (
          <div className="bg-white rounded-xl p-3 flex items-center border border-gray-200 shadow-sm">
            <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
              <SiLine size={16} />
            </div>
            <span className="ml-3 text-sm font-medium">LINE Connected</span>
            <div className="ml-auto">
              <span className="text-xs text-green-600 bg-green-50 px-2 py-1 rounded-full">Connected</span>
            </div>
          </div>
        )}

        {/* Simple Icon + Label Items */}
        <div className="space-y-2">
          {/* Manage Subscriptions */}
          <Link
            to="/subscription-management"
            className="flex items-center justify-between p-4 hover:bg-white hover:rounded-xl transition-all"
          >
            <div className="flex items-center">
              <SettingsIcon />
              <span className="ml-4 text-gray-900">{t('subscription.manageSubscription')}</span>
            </div>
            <ChevronRightIcon />
          </Link>

          {/* Gift Subscriptions */}
          <Link
            to="/gift-subscription"
            className="flex items-center justify-between p-4 hover:bg-white hover:rounded-xl transition-all"
          >
            <div className="flex items-center">
              <Gift />
              <span className="ml-4 text-gray-900">{t('subscription.giftSubscription')}</span>
            </div>
            <ChevronRightIcon />
          </Link>

          {/* Manage Addresses */}
          <Link
            to="/address"
            className="flex items-center justify-between p-4 hover:bg-white hover:rounded-xl transition-all"
          >
            <div className="flex items-center">
              <MapPinIcon />
              <span className="ml-4 text-gray-900">{t('account.manageAddresses')}</span>
            </div>
            <ChevronRightIcon />
          </Link>

          {/* Refund History */}
          <Link
            to="/refund-history"
            className="flex items-center justify-between p-4 hover:bg-white hover:rounded-xl transition-all"
          >
            <div className="flex items-center">
              <RefreshCcwIcon />
              <span className="ml-4 text-gray-900">{t('subscription.refundHistory')}</span>
            </div>
            <ChevronRightIcon />
          </Link>

          {/* Contact Us */}
          <Link
            to="/contact"
            className="flex items-center justify-between p-4 hover:bg-white hover:rounded-xl transition-all"
          >
            <div className="flex items-center">
              <MessageCircleIcon />
              <span className="ml-4 text-gray-900">{t('pages.contact.title')}</span>
            </div>
            <ChevronRightIcon />
          </Link>


          <div className="h-[2px] bg-gray-100 my-2"></div>

          {/* Logout */}
          <button
            onClick={() => setShowConfirmationLogout(true)}
            className="bg-white border-none flex items-center justify-between w-full p-4 hover:bg-white hover:rounded-xl transition-all text-left"
          >
            <div className="flex items-center">
              <LogOutIcon />
              <span className="ml-4 text-gray-900">{t('auth.logout')}</span>
            </div>
            <ChevronRightIcon />
          </button>
        </div>
      </div>

      {showConfirmationLogout && (
        <ConfirmationModal
          show={[showConfirmationLogout, setShowConfirmationLogout]}
          onConfirm={handleLogout}
        />
      )}
    </main>
  )
} 